import React from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';
import placeholder from './200.png';

export const ProductImageBase = ({
  backImageAlt,
  frontImageAlt,
  backImageOnHover,
  frontImageOnHover,
  imgOnHover,
  img,
}) => (
  <div className={styles.imgContainer}>
    <img
      alt={backImageAlt}
      className={cn(styles.backImage, backImageOnHover)}
      src={imgOnHover || img || placeholder}
    />
    <img
      alt={frontImageAlt}
      className={cn(styles.frontImage, frontImageOnHover)}
      src={img || placeholder}
    />
  </div>
);
